<template>
  <div class="connect-pic">
    <img src="@/assets/images/connectPic.png" mode="widthFix"/>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
  .connect-pic {
    height: 100%
    overflow hidden
    font-size 0
    img {
      width 100%
      height auto
    }
  }
</style>